import React, { useState, useEffect } from "react";
import {
  getRoomReadys,
  sendRoomReadyNotificationEmail,
} from "services/roomReadys";
import { Icon, Popup } from "semantic-ui-react";
import Loader from "components/Loader";
import ListTable from "components/RoomReady/ListTable";
import FilterPopup from "components/RoomReady/FilterPopup";
import AddOrEditWaitForRoomPopup from "components/RoomReady/AddOrEditWaitForRoomPopup";
import FilterBar from "components/RoomReady/FilterBar";
import DeletePopup from "components/RoomReady/DeletePopup";
import MessagePopup from "components/MessagePopup";
import { getAllNotificationMethods } from "services/notifications";
import WeChatQrCodePopup from "components/RoomReady/WeChatQrCodePopup";
import { parseBpCommentString } from "utils/commentParser";

export default function RoomReady(props: any) {
  // const [initialFetch, setInitialFetch] = useState<boolean>(true)
  const { hotel } = props;
  const defaultRoomReady = {
    hotelId: hotel.id,
    email: "",
    phoneNumber: "",
    language: "en",
    bookingNumber: "",
    firstName: "",
    lastName: "",
    notificationMethodIds: [],
    isNew: false,
  };
  const [loading, setLoading] = useState(false);
  const [fetchCount, setFetchCount] = useState(0);
  const [filter, setFilter] = useState({ notSend: false, filtering: false });
  const [bookingFilter, setBookingFilter] = useState<any>({
    bookingNumber: null,
    email: null,
    fullName: null,
    firstName: null,
    lastName: null,
  });
  const [roomReadys, setRoomReadys] = useState<any>(null);
  /* use for editPopup component to update info */
  const [roomReady, setRoomReady] = useState(defaultRoomReady);
  const [notificationMethods, setNotificationMethods] = useState<any[]>([]);
  const [bookings, setBookings] = useState<any>(null);
  const [popup, setPopup] = useState<any>({
    addWaitForRoom: false, // also for edit
    wechatQrcode: false,
    edit: false,
    delete: false,
  });
  const [qrCode, setQrCode] = useState<any>({
    qrcode: "",
    url: "",
  });

  const [queryString, setQueryString] = useState<any>({
    any: "",
    email: "",
    confirmationNumber: "",
    firstName: "",
    lastName: "",
    checkInDate: "",
  });

  /* for initial get all records */
  useEffect(() => {
    getData();
  }, [fetchCount]);

  const getData = async () => {
    const query = getQueryString();
    setLoading(true);
    const roomReadys = await getRoomReadys(query);
    const notificationMethodsResp = await getAllNotificationMethods(query);
    setNotificationMethods([...notificationMethodsResp]);
    setRoomReadys([
      ...roomReadys.map((item: any) => {
        const commentArray = parseBpCommentString(item.comments);
        const wfrComment = commentArray.find(
          (comment) => comment.code === "WFR1"
        );
        return {
          ...item,
          email: wfrComment?.email || item.email,
          phoneNumber: wfrComment?.phoneNumber || item.phoneNumber,
        };
      }),
    ]);
    setLoading(false);
  };

  const getQueryString = () => {
    // console.log(queryString)
    const allEmpty = Object.values(queryString).every((value) => !value);
    // console.log("allEmpty", allEmpty)
    if (allEmpty) return "";

    const queries = Object.keys(queryString)
      .filter((key) => {
        return !!queryString[key];
      })
      .map((key) => {
        return `"${key}":"${queryString[key]}"`;
      })
      .join(",");

    const conditionJson = queries ? `{${queries}}` : "";
    // console.log("conditionJson",conditionJson)
    return `?filter=${conditionJson}`;
  };

  const searchByQueryString = async () => {
    setRoomReadys(null);
    await getData();
  };

  const sendRoomReadyNotification = async (roomReady: any) => {
    const response = await sendRoomReadyNotificationEmail(roomReady);
    // console.log("email response:", response)
    return response;
  };

  const updateRecordListByBookingNumber = (
    bookingNumber: string,
    newEmail: string
  ): void => {
    if (popup.addWaitForRoom) {
      const index = bookings.findIndex(
        (booking: any) => booking.confirmationNumber === bookingNumber
      );
      // console.log("??bb",index,newEmail,bookings[index])
      bookings.splice(index, 1, { ...bookings[index], email: newEmail });
      setBookings([...bookings]);
    } else {
      const index = roomReadys.findIndex(
        (booking: any) => booking.confirmationNumber === bookingNumber
      );
      // console.log("??aa",index,newEmail,roomReadys[index])
      roomReadys.splice(index, 1, { ...roomReadys[index], email: newEmail });
      setRoomReadys([...roomReadys]);
    }
  };

  return (
    <>
      <MessagePopup />
      {/* popup for show the booking search results */}
      <AddOrEditWaitForRoomPopup
        {...{
          notificationMethods,
          popup,
          setPopup,
          setBookingFilter,
          roomReady,
          setRoomReady,
          fetchCount,
          setFetchCount,
          hotel,
          // qrCode,
          setQrCode,
        }}
      />
      <WeChatQrCodePopup {...{ qrCode, popup, setPopup }} />
      <DeletePopup
        {...{ popup, setPopup, roomReady, fetchCount, setFetchCount }}
      />
      {!roomReadys ? (
        <Loader text="loading..." />
      ) : (
        <>
          <FilterBar
            {...{
              queryString,
              setQueryString,
              searchByQueryString,
              setRoomReadys,
              loading,
              setLoading,
            }}
          />
          <ListTable
            hotel={hotel}
            roomReadys={roomReadys}
            setRoomReady={setRoomReady}
            popup={popup}
            setPopup={setPopup}
            sendRoomReadyNotification={sendRoomReadyNotification}
            filter={filter}
            setFilter={setFilter}
            fetchCount={fetchCount}
            setFetchCount={setFetchCount}
            bookingFilter={bookingFilter}
            setBookingFilter={setBookingFilter}
            queryString={queryString}
          />
        </>
      )}

      <Popup
        content="Add Wait for room"
        trigger={
          <div
            className="flex w-12 h-12 rounded-full bg-yellow-300 fixed bottom-10 right-10 cursor-pointer"
            onClick={() => {
              setRoomReady({ ...defaultRoomReady, isNew: true });
              setPopup({ ...popup, addWaitForRoom: true });
            }}
          >
            <Icon
              style={{ margin: "auto" }}
              color="black"
              name="plus"
              size="large"
            />
          </div>
        }
      />
    </>
  );
}
